<template>
    <div class="page-class"
        :class="[{'page-mass': theme == 'mass'}, {'page-prestige': theme == 'prestige'}]">
        <AIAHeaderSearch
            :lbl="lbl"
            v-model="searchTxt"
            @onBack="onBack()"
            @onClear="onClear()"
            @onSearch="onSearch()" />

        <SearchHistory
            ref="search_history"
            :lbl="lbl"
            :modalController="modalController"
            v-model="searchTxt"
            @onSelectKeyWord="onSearch()"
            v-if="!isSearch" />
        <SearchList
            ref="search_list"
            :lbl="lbl"
            :searchTxt="searchTxt"
            :modalController="modalController"
            v-if="isSearch" />

        <ModalMaster :controller="modalController" />
    </div>
</template>
<script>
// mixin
import ErrorApiMixin from '@/mixin/ErrorApiMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
// component
import AIAHeaderSearch from '@/components/Layout/header/AIAHeaderSearch.vue';
import SearchHistory from '../component/Search/SearchHistory.vue';
import SearchList from '../component/Search/SearchList.vue';
// modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import ModalFactory from "@/components/Modal/ModalFactory.js";
export default {
    name: 'RewardSearch',
    mixins: [ErrorApiMixin, LocaleMixin],
    components: {
        AIAHeaderSearch,
        SearchHistory,
        SearchList,
        ModalMaster
    },
    computed: {
        isAmbassador: function () {
            return this.$store.state.isAmbassador;
        },
        theme: function () {
            return this.$store.state.theme;
        }
    },
    data: function () {
        return {
            isSearch: false,
            searchTxt: '',
        };
    },
    created: function () {
        let modalFactory = new ModalFactory();
        this.modalController = modalFactory.getModalController();
        this.alertModal = modalFactory.getAlertModal();
        this.loadingModal = modalFactory.getLoadingModal();
        this.noInternetModal = modalFactory.getNoInternetModal();

        this.errorHandler.setAlertModal(this.modalController.alertModal);
        this.errorHandler.setNoInternetModal(this.modalController.noInternetModal);
    },
    methods: {
        //#region event
        onBack: function () {
            this.$router.back();
        },
        onClear: function () {
            this.isSearch = false;
            this.$nextTick(() => {
                this.$refs['search_history'].getList();
            });
        },
        onSearch: function () {
            this.isSearch = true;
            this.$nextTick(() => {
                this.$refs['search_list'].search();
            });
        },
        //#endregion event
        //#region search history
        initSearchHistory: function () {

        },  
        //#endregion search history
        //#region campaign list
        //#endregion campaign list
    }
}
</script>